import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import * as React from 'react';
import { connect } from 'react-redux';

import { ApplicationState } from '../Store';
import { GetAppInsightsConfig } from '../Store/AppSettings';
import { reactPlugin } from './Logging';

type InjectedReduxState = {
    appInsightsDisabled: boolean;
    appInsightsInstrumentationKey: string;
};

type InjectedActionCreators = {}

type LoggingWrapperProps = {
    children?: React.ReactNode;
};

type Props = InjectedReduxState & InjectedActionCreators & LoggingWrapperProps;

const LoggingWrapperComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        appInsightsDisabled
    } = props;

    if (appInsightsDisabled) {
        return (<React.Fragment>{props.children}</React.Fragment>);
    } else {
        return (
            <AppInsightsContext.Provider value={reactPlugin}>
                {props.children}
            </AppInsightsContext.Provider>
        );
    }
}

export const LoggingWrapper = connect<InjectedReduxState, InjectedActionCreators, LoggingWrapperProps, ApplicationState>(
    (appState: ApplicationState) => {
        const appInsights = GetAppInsightsConfig(appState);

        return {
            appInsightsDisabled: appInsights.disabled,
            appInsightsInstrumentationKey: appInsights.instrumentationKey,
        };
    }
)(LoggingWrapperComponent);
